import { getText } from "@utils/getText";
import { Button, Card, Descriptions, message, Table, Tag, Space } from "antd";
import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Column from "antd/lib/table/Column";
import { OrderDetailsPageProps } from "./orderDetailsPageContainer";

export const OrderDetailsPage: React.FC<OrderDetailsPageProps> = (props) => {
    const { order, approveOrderArticle, rejectOrderArticle } = props;
    const intl = useIntl();

    const orderData = order?.articleOrders?.[0];

    const handleApprove = async (articleId: string) => {
        try {
            const result = await approveOrderArticle({
                variables: {
                    orderId: props.match.params.id,
                    articleId,
                    userId: orderData?.user?.id!
                }
            });
            if (result.data?.approveOrderArticle.success) {
                message.success(intl.formatMessage({ id: "order.article.approved" }));
                order.refetch().catch((e) => console.error(e));
            } else {
                message.error(intl.formatMessage({ id: "order.article.approveError" }));
            }
        } catch (e) {
            console.error(e);
            message.error(intl.formatMessage({ id: "order.article.approveError" }));
        }
    };

    const handleReject = async (articleId: string) => {
        try {
            const result = await rejectOrderArticle({
                variables: {
                    orderId: props.match.params.id,
                    articleId,
                    userId: orderData?.user?.id!
                }
            });
            if (result.data?.rejectOrderArticle.success) {
                message.success(intl.formatMessage({ id: "order.article.rejected" }));
                order.refetch();
            } else {
                message.error(intl.formatMessage({ id: "order.article.rejectError" }));
            }
        } catch (e) {
            message.error(intl.formatMessage({ id: "order.article.rejectError" }));
        }
    };

    if (order?.loading) {
        return <Card loading />;
    }

    if (!orderData) {
        return <Card><FormattedMessage id="order.notFound" /></Card>;
    }

    const { user, addressInfo, orders: items } = orderData;

    return (
        <div style={{ padding: "24px" }}>
            <h1>
                <FormattedMessage id="order.details" />
:
                {" "}
                {orderData.id}
            </h1>
            <Space
                direction="vertical"
                size="large"
                style={{ width: "100%" }}
            >
                <Card title={<FormattedMessage id="order.customerInfo" />}>
                    <Descriptions bordered>
                        <Descriptions.Item label={<FormattedMessage id="user.name" />}>
                            {user.email}
                        </Descriptions.Item>
                        <Descriptions.Item label={<FormattedMessage id="user.email" />}>{user.email}</Descriptions.Item>
                    </Descriptions>
                </Card>

                <Card title={<FormattedMessage id="order.shippingAddress" />}>
                    <Descriptions bordered>
                        <Descriptions.Item label={<FormattedMessage id="address.street" />}>
                            {addressInfo.street}
                            /
                            {addressInfo.number}
                        </Descriptions.Item>
                        <Descriptions.Item label={<FormattedMessage id="address.city" />}>{addressInfo.city}</Descriptions.Item>
                        <Descriptions.Item label={<FormattedMessage id="address.zip" />}>{addressInfo.zip}</Descriptions.Item>
                        <Descriptions.Item label={<FormattedMessage id="address.country" />}>{addressInfo.country}</Descriptions.Item>
                    </Descriptions>
                </Card>

                <Card title={<FormattedMessage id="order.items" />}>
                    <Table
                        dataSource={items}
                        pagination={false}
                        rowKey={(record) => record.article.id}
                    >
                        <Column
                            key="title"
                            render={(_, record: any) => getText(record.article.title)}
                            title={<FormattedMessage id="article.title" />}
                        />
                        <Column
                            key="amount"
                            dataIndex="amount"
                            title={<FormattedMessage id="article.amount" />}
                        />
                        <Column
                            key="status"
                            dataIndex="status"
                            render={(status: string) => (
                                // eslint-disable-next-line no-nested-ternary
                                <Tag color={status === "pending" ? "orange" : status === "approved" ? "green" : "red"}>
                                    {status?.toUpperCase() || "unknown"}
                                </Tag>
                            )}
                            title={<FormattedMessage id="article.status" />}
                        />
                        <Column
                            key="actions"
                            render={(_, record: any) => (
                                // eslint-disable-next-line no-nested-ternary
                                record.status === "pending" ? (
                                    <Space>
                                        <Button
                                            type="primary"
                                            onClick={() => handleApprove(record.article.id)}
                                        >
                                            <FormattedMessage id="approve" />
                                        </Button>
                                        <Button
                                            danger
                                            onClick={() => handleReject(record.article.id)}
                                        >
                                            <FormattedMessage id="reject" />
                                        </Button>
                                    </Space>
                                ) : record.status === "approved" ? (
                                    <Space>
                                        <Button
                                            danger
                                            onClick={() => handleApprove(record.article.id)}
                                        >
                                            <FormattedMessage id="sendMailAgain" />
                                        </Button>
                                    </Space>
                                ) : null
                            )}
                            title={<FormattedMessage id="actions" />}
                        />
                    </Table>
                </Card>
            </Space>
        </div>
    );
};
